import * as types from "./types";

const initialState = {
  profile: null,
  loading: false,
  notFound: false,
};

const companyApplicantProfile = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_APPLICANT_PROFILE_REQUEST:
      return { ...state, loading: true, notFound: false };
    case types.GET_COMPANY_APPLICANT_PROFILE_RESPONSE:
      return {
        ...state,
        loading: false,
        profile: action.payload?.profile ?? null,
        notFound: Boolean(action.payload?.notFound),
      };
    case types.CLEAR_COMPANY_APPLICANT_PROFILE:
      return initialState;
    default:
      return state;
  }
};

export default companyApplicantProfile;
